import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface DeleteProps {
  isB2B: boolean;
}

export const GiftCardDelete = ({ isB2B }: DeleteProps) => {
  return (
    <>
      <Typography variant="body-base">
        This will remove the card from your account. You can still use the balance with the card
        number and PIN at checkout.
      </Typography>
      <br />
      {isB2B && (
        <Typography variant="body-base">
          Purchase history associated with this card will remain available in your account.
        </Typography>
      )}
    </>
  );
};
